<div class="content-wrapper reports-container">
  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="margin-top: 19px"
  >
    <a class="widget quick-category">
      <div class="quick-category-content">
        <div class="row" [ngbCollapse]="areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.createdDate' | translate }}
              </h6>
              <div>
                <input
                  bsDaterangepicker
                  class="form-control"
                  type="text"
                  placeholder="Selecione una fecha"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue test',
                    adaptivePosition: true,
                    rangeInputFormat: 'DD/MM/YYYY'
                  }"
                  [(ngModel)]="rangeDate"
                  [ngModelOptions]="{ standalone: true }"
                  [maxDate]="maxDateInput"
                  (bsValueChange)="setDate($event)"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.userFilter' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="users"
                [closeOnSelect]="false"
                [(ngModel)]="selectedUsers"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.table.section' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="actions"
                bindLabel="name"
                bindValue="id"
                [closeOnSelect]="false"
                [(ngModel)]="selectedActions"
                multiple="true"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="btn-filtros">
              <button
                style="padding: 5px 30px; width: 140px"
                [disabled]="!canSync"
                (click)="syncUp()"
                class="btn btn-primary"
              >
                {{ 'home.sync' | translate }}
              </button>
              <button
                style="padding: 5px 30px; width: 110px"
                type="button"
                class="btn btn-primary"
                (click)="setFilters()"
              >
                {{ 'record.filter.filter' | translate }}
              </button>
              <button
                style="padding: 5px 0px; width: 110px"
                type="button"
                class="btn btn-outline-primary"
                (click)="cleanFilters()"
              >
                {{ 'record.filter.cleanFilters' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>

    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 25px;
              width: 165px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
            type="button"
            class="btn btn-primary"
            (click)="download()"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'record.download.download' | translate }}
          </button>
          <!--
            <button
            style="
              padding: 5px;
              width: 100px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
              type="button"
              class="btn btn-outline-primary"
            >
              <i class="icon excel" style="height: 17px"></i>
              {{ 'record.exportToExcel' | translate }}
            </button>
          -->
        </div>
        <div>
          {{
            'record.recordsCount'
              | translate
                : { count: reports?.length || '0', total: collectionSize }
          }}
        </div>
      </div>
    </div>

    <form>
      <table class="table table-striped">
        <thead>
          <tr>
            <th style="width: 200px" scope="col">
              {{ 'record.table.date' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.company' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.section' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.message' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.createdBy' | translate }}
            </th>
            <th scope="col">
              {{ 'record.table.opt' | translate }}
            </th>
          </tr>
        </thead>
        <tbody *ngIf="isLoading">
          <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
          </tr>
        </tbody>
        <tbody *ngIf="!isLoading">
          <tr *ngFor="let report of reports">
            <td>{{ report.lastModifiedDate | tableDate }}</td>
            <td>{{ report.company }}</td>
            <td>{{ report.section }}</td>
            <td>{{ report.message | cutString }}</td>
            <td>{{ report.user }}</td>
            <td>
              <button
                (click)="seeDetails(report.message, report.id)"
                style="border: none; padding: 0; background: transparent"
              >
                <i class="las la-eye font-25"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="reports?.length <= 0" class="d-flex justify-content-center">
        <span>{{ 'noDataAvailable' | translate }}</span>
      </div>
    </form>
  </div>

  <div
    class="d-flex justify-content-center p-2 paginator-container"
    *ngIf="reports?.length > 0"
  >
    <div class="items-per-page-container">
      <label for="pageSizeSelect" class="mr-2 mb-0">{{
        'record.filter.itemsPerPage' | translate
      }}</label>
      <select
        id="pageSizeSelect"
        class="form-control"
        style="width: auto; display: inline-block"
        [(ngModel)]="pageSize"
        (change)="refreshReports()"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [maxSize]="5"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshReports()"
    >
    </ngb-pagination>
  </div>
</div>
